import { ReactComponent as CheckSvg } from '../../assets/icons/check.svg';

export const CheckIcon: SvgIcon = (props) => {
    return <CheckSvg {...props} />;
};
